import isArray from 'lodash/isArray';
import typeOf from 'common/js_utils/typeOf';
import assert from 'common/assertions/assert';

/**
 * Ensures the given value is of Array type.
 * @param value The value to check
 * @throws An AssertionError if the check fails
 */
export default (value: unknown) =>
  assert(isArray(value), `Expected ${value} to be an Array, was ${typeOf(value)}`);
